import Masonry from 'masonry-layout'
import 'slick-carousel'

export default (() => {
  const grid = document.querySelector('.masonry-grid')
  const masonryTiles = document.querySelectorAll('.masonry-grid .tile')
  var imageModalSlider = $('.wrap-modal-slider')
  let msnry
  const breakPoint = 768
  let masonarySet = false
  var shortestHeight = false
  var imgCountLoaded = 0

  if (!grid) {
    return
  }

  // if (window.innerWidth >= breakPoint) {
  //   imageModalSlider.slick('unslick')
  //   destroyCarousel()
  //   initMasonary()
  // }

  window.addEventListener('resize', function () {
    onResize()
  })

  function addModalAttributes() {
    masonryTiles.forEach((el) => {
      el.setAttribute('data-toggle', 'modal')
      el.setAttribute('data-target', '#image-carousel-modal')
    })
  }

  function removeModalAttributes() {
    masonryTiles.forEach((el) => {
      el.removeAttribute('data-toggle', 'modal')
      el.removeAttribute('data-target', '#image-carousel-modal')
    })
  }

  $('.modal').on('shown.bs.modal', function (e) {
    $('.wrap-modal-slider').slick('setPosition')
    $('.modal-content').addClass('open')
  })

  //init masonary
  function initMasonary() {
    // msnry = new Masonry(grid, {
    //   itemSelector: '.tile',
    //   percentPosition: true,
    //   gutter: 30,
    //   horizontalOrder: false,
    //   originLeft: true,
    //   columnWidth: '.tile',
    // })

    msnry = new Masonry(grid, {
      itemSelector: '.tile',
      percentPosition: true,
      gutter: 30,
      horizontalOrder: false,
      originLeft: true,
      columnWidth: '.tile',
    })

    setTimeout(() => {
      msnry.once('layoutComplete', () => {
        grid.classList.add('load')
        // addModalAttributes()
      })

      msnry.layout()

    }, 200)
  }

  function onResize() {
    if (window.innerWidth < breakPoint && !masonarySet) {
      initImageHeights(true)
      initCarousel()
      // console.log(3)
    } else if (window.innerWidth < breakPoint && masonarySet) {
      initImageHeights(true)
      initCarousel()
      expandItem()
      // console.log(2)
    } else if (window.innerWidth >= breakPoint && !masonarySet) {
      destroyCarousel()
      initMasonary()
      expandItem()
      masonarySet = true
      // console.log(3)
    } else if (window.innerWidth >= breakPoint && masonarySet) {
      msnry.reloadItems()
      // console.log(4)
    }
  }

  // Make all images the same height as the shortest image
  var shortestHeight = false

  function destroyCarousel() {
    $('.slick-initialized').each(function () {
      var imageSlider = $(this)
      if (imageSlider) {
        imageSlider.slick('destroy')
      }
    })

    $('.masonry-grid .tile img').each(function () {
      $(this).removeAttr('style')
    })
  }

  function initImageHeights(reinit) {
    var $images = $('.masonry-grid .tile img')

    shortestHeight = false
    if (reinit) {
      setTimeout(function () {
        $images.removeAttr('style')
        imageHeights($images, false)
      }, 100)
    } else {
      $images
        .one('load', function () {
          // A slide image has loaded
          imgCountLoaded++
          if (imgCountLoaded == $images.length) {
            // Only fire resize logic when last image is loaded
            imageHeights($images, false)
          }
        })
        .each(function () {
          // Manual fire "load" event if image is coming from cache
          if (this.complete) {
            $(this).trigger('load')
          }
        })
    }
  }

  function imageHeights($images, reinit) {
    $images.each(function () {
      // Loop each image, check if height is shortest
      if (!shortestHeight || $(this).height() < shortestHeight) {
        shortestHeight = $(this).height()
      }
    })
    if (shortestHeight) {
      $images.css({ height: shortestHeight, width: 'auto' }) // Reset heights of all images to shortest
    }
    initCarousel(reinit)
  }

  // // Init slick
  function initCarousel(reinit) {
    if (msnry) {
      msnry.destroy()
      $('.masonry-grid').removeAttr('style')
      // removeModalAttributes()
    }
    initImageHeights(false)
    $('.masonry-grid').each(function () {
      var imageSlider = $(this)

      if (reinit) {
        imageSlider.slick('destroy')
      }

      imageSlider.not('.slick-initialized').slick({
        adaptiveHeight: true,
        dots: true,
        arrows: false,
      })
    })
    masonarySet = false
  }

  function initModalCarousel(reinit) {
    if (reinit) {
      imageModalSlider.slick('destroy')
    }

    imageModalSlider.not('.slick-initialized').slick({
      adaptiveHeight: true,
      dots: true,
      arrows: false,
    })
  }

  function expandItem () {
      if (window.innerWidth >= breakPoint) {
        // expandItem(grid)

        $('.masonry-grid .tile img').on('click', function(event) {
          // $(event.currentTarget).parent().toggleClass('is-expanded')
          // console.log('clicked')
          if(!$(event.currentTarget).parent().hasClass('is-expanded')) {
            $('.masonry-grid .tile').removeClass('is-expanded')

          }

          $(event.currentTarget).parent().toggleClass('is-expanded')

          setTimeout(()=> {
            msnry.layout()
          }, 200)
        })
      } else {
        $('.masonry-grid .tile img').off()
      }
  }

  onResize()
  // expandItem()
  // console.log('resize')
})()
